var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDisplay)?_c('Button',{attrs:{"icon":_vm.attrs.icon,"loading":_vm.isLoading,"type":_vm.attrs.btnStyle},on:{"click":_vm.handleClick}},[_vm._v("\n    "+_vm._s(_vm.attrs.title)+"\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cfbb96d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../projectCore/src/components/power-button/src/index.vue
// module id = null
// module chunks = 